import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ApprovalRequest } from '.';

export interface LoadingStatus {
    serverRequestInProgress: boolean;
    loaded: boolean;
}

export interface State extends EntityState<ApprovalRequest>, LoadingStatus {}

export const adapter: EntityAdapter<ApprovalRequest> = createEntityAdapter<ApprovalRequest>();

export const initialState: State = adapter.getInitialState({
    serverRequestInProgress: false,
    loaded: false,
});
